export default "__VITE_ASSET__KN4VpdZq__"